import * as React from 'react';
import styled from 'styled-components'

import HeadlineMiddle from "./common/atom/text/headline_middle";
import Paragraph from "./common/atom/text/paragraph";
import BtnCorporateMiddle from "./common/atom/btn/btn_corporate_middle";
import PageWrapper from "./common/atom/wrapper/page_wrapper";

interface IProps {
    handleClick: () => void;
}

const FeedbackForError: React.FC<IProps> = (props) => {

    const {handleClick} = props;

    return (
        <Wrapper>
            <HeadlineMiddle>エラー発生</HeadlineMiddle>
            <Paragraph>ページを再読み込みしてください。</Paragraph>
            <FeedbuckButton onClick={handleClick}>再読み込み</FeedbuckButton>
        </Wrapper>
    )
};

const Wrapper = styled(PageWrapper)`
  text-align: center;
`;

const FeedbuckButton = styled(BtnCorporateMiddle)`
  margin-top: 20px;  
  width: 200px;
`;


export default FeedbackForError;



// WEBPACK FOOTER //
// ./src/presentation/FeedbackForError.tsx